var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.441,
    height: 150.166,
    viewBox: "0 0 118.441 150.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "permission",
    transform: "translate(-768.978 -266.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13085",
    "data-name": "Group 13085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13084",
    "data-name": "Group 13084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16628",
    "data-name": "Path 16628",
    d: "M821.732,318.71l-3.023,5.213a8.306,8.306,0,0,1-4.475,3.683l-11,3.794a12.6,12.6,0,0,0-1.488.46l-.175.065a14.328,14.328,0,0,0-9.133,13.47l-1.879,16.042",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16629",
    "data-name": "Path 16629",
    d: "M834.664,318.71l3.024,5.213a8.308,8.308,0,0,0,4.474,3.683l11,3.794a12.528,12.528,0,0,1,1.487.46l.176.065a14.327,14.327,0,0,1,9.132,13.47l1.879,16.042",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4945",
    "data-name": "Line 4945",
    x2: 12.074,
    transform: "translate(842.616 352.153)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16631",
    "data-name": "Path 16631",
    d: "M831.426,332.312l3.238,20.7-6.467,8.411v.011l0-.005,0,.005v-.011l-6.467-8.411,3.238-20.7,3.24,3.5Z",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16635",
    "data-name": "Path 16635",
    d: "M841.4,289.582s-24.205.055-28.967-5.727-.34-14.795-.34-14.795,26.473-3.8,29.59-1.189a10.013,10.013,0,0,1,3.515,4.2,29.185,29.185,0,0,1,1.02,11.785c-.453,2.1-.624,2.721-.624,2.721Z",
    fill: "#c06c84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13083",
    "data-name": "Group 13083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13082",
    "data-name": "Group 13082"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4943",
    "data-name": "Line 4943",
    y1: 6.141,
    transform: "translate(828.187 274.366)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4944",
    "data-name": "Line 4944",
    x2: 6.142,
    transform: "translate(825.116 277.437)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16630",
    "data-name": "Path 16630",
    d: "M810.929,289.594c.174,4.29,1.638,17.468,6.083,24.563a12.954,12.954,0,0,0,22.34,0c3.5-5.374,4.873-16.134,5.338-21.091a2.9,2.9,0,0,0-2.341-3.12,113.088,113.088,0,0,0-16.564-1.823c-5.589-.256-11.869-1.2-15.481-5.956v-8.309a5.921,5.921,0,0,1,5.921-5.921h23.924a5.92,5.92,0,0,1,5.921,5.92v11.956",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16632",
    "data-name": "Path 16632",
    d: "M854.69,285.1h21.44a8.392,8.392,0,0,1,8.392,8.392v66.849a8.392,8.392,0,0,1-8.392,8.392H780.266a8.391,8.391,0,0,1-8.391-8.392V293.495a8.391,8.391,0,0,1,8.391-8.392h23.2",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16633",
    "data-name": "Path 16633",
    d: "M799.467,368.736l-5.12,12.943h67.7l-5.12-12.943",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16634",
    "data-name": "Path 16634",
    d: "M875.561,391.493l9.8,17.687a3.989,3.989,0,0,1-3.49,5.923H774.522a3.989,3.989,0,0,1-3.489-5.923l9.8-17.687Z",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13086",
    "data-name": "Group 13086"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4946",
    "data-name": "Line 4946",
    transform: "translate(785.718 403.298)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4947",
    "data-name": "Line 4947",
    x2: 70.804,
    transform: "translate(795.149 403.298)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "0 9.43"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4948",
    "data-name": "Line 4948",
    transform: "translate(870.678 403.298)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.78c787cba61b5e3a0ca5546b56a3ca2e.svg";
export { ForwardRef as ReactComponent };